<div class="modal-header">
  <h4 class="modal-title me-auto" id="modal-basic-title">Change Plan</h4>
  <button
    data-dd-action-name="confirm-change-plan-modal.close-button"
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCancel()"
  ></button>
</div>
<div class="modal-body pb-0">
  <p>
    You've chosen a {{ packageDisplayName }} plan which doesn't include
    {{ featureText }} you're using:
  </p>

  <ul>
    @for (feature of usedFeaturesNotInPlanDisplay; track feature) {
      <li>
        {{ feature }}
      </li>
    }
  </ul>

  <p>If you continue {{ featureText }} will be disabled.</p>
</div>

<div class="modal-footer">
  @if (!featureIsOnlyInCustomPlan) {
    <button
      data-dd-action-name="confirm-change-plan-modal.choose-another-plan-button"
      type="button"
      class="btn btn-outline ms-2"
      (click)="onCancel()"
    >
      Choose Another Plan
    </button>
  }
  @if (featureIsOnlyInCustomPlan) {
    <button
      data-dd-action-name="confirm-change-plan-modal.cancel-button"
      type="button"
      class="btn btn-outline ms-2"
      (click)="onCancel()"
    >
      Cancel
    </button>
  }
  <button
    data-dd-action-name="confirm-change-plan-modal.continue-button"
    type="button"
    class="btn btn-primary"
    (click)="onUpdate()"
  >
    Continue
  </button>
</div>
